(function () {
  function esc(value) {
    return String(value ?? "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  const moneyFormat = document.body.dataset.moneyFormat || "{{amount}} PLN";

  function formatMoney(cents) {
    const value = (cents / 100).toFixed(0);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, value)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, value);
  }

  const drawer = document.querySelector("[data-cart-drawer]");
  const body = document.querySelector("[data-cart-body]");
  const countNodes = () => document.querySelectorAll("[data-cart-count]");

  function openCart() {
    if (!drawer) return;
    drawer.hidden = false;
  }
  function closeCart() {
    if (!drawer) return;
    drawer.hidden = true;
  }

  document.querySelectorAll("[data-cart-open]").forEach((button) => {
    button.addEventListener("click", async () => {
      await renderCart();
      openCart();
    });
  });
  document.querySelectorAll("[data-cart-close]").forEach((button) => {
    button.addEventListener("click", closeCart);
  });

  const menuButton = document.querySelector("[data-menu-toggle]");
  const nav = document.querySelector("[data-nav]");
  if (menuButton && nav) {
    menuButton.addEventListener("click", () => {
      const open = nav.classList.toggle("is-open");
      menuButton.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }

  async function renderCart() {
    const cart = await fetch("/cart.js", { headers: { Accept: "application/json" } }).then((r) => r.json());
    countNodes().forEach((node) => {
      node.textContent = String(cart.item_count);
    });
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<p class="ax-muted" style="padding:1rem">Koszyk jest pusty.</p>';
      return;
    }
    const items = cart.items
      .map((item) => {
        const plan = item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.name : "Jednorazowo";
        const image = item.image ? `<img src="${esc(item.image)}" alt="">` : "";
        return `<article class="ax-line">
          ${image}
          <div>
            <strong>${esc(item.product_title)}</strong>
            <p class="ax-muted">${esc(plan)}</p>
            <div class="ax-line__qty">
              <button type="button" data-change="${item.key}" data-delta="-1" aria-label="Mniej">−</button>
              <span class="ax-mono">${item.quantity}</span>
              <button type="button" data-change="${item.key}" data-delta="1" aria-label="Więcej">+</button>
              <span class="ax-mono" style="margin-left:auto">${formatMoney(item.final_line_price)}</span>
            </div>
          </div>
        </article>`;
      })
      .join("");
    body.innerHTML = `${items}<div class="ax-checkout">
      <p class="ax-mono">${formatMoney(cart.total_price)}</p>
      <a class="ax-btn ax-btn--cobalt" href="/checkout">Do kasy</a>
    </div>`;
    body.querySelectorAll("[data-change]").forEach((button) => {
      button.addEventListener("click", async () => {
        const key = button.getAttribute("data-change");
        const delta = Number(button.getAttribute("data-delta"));
        const current = cart.items.find((item) => item.key === key);
        const quantity = Math.max(0, (current ? current.quantity : 1) + delta);
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity }),
        });
        await renderCart();
      });
    });
  }

  document.querySelectorAll(".ax-product-form").forEach((form) => {
    const qty = form.querySelector("[data-qty-input]");
    form.querySelectorAll("[data-qty]").forEach((button) => {
      button.addEventListener("click", () => {
        const next = Math.min(6, Math.max(1, Number(qty.value || 1) + Number(button.dataset.qty)));
        qty.value = String(next);
      });
    });

    function syncPlan(input) {
      form.querySelectorAll(".ax-plan").forEach((label) => label.classList.remove("is-selected"));
      const label = input.closest(".ax-plan");
      if (label) label.classList.add("is-selected");
      const price = input.dataset.planPrice || "";
      const labelText = input.dataset.planLabel || "";
      const add = form.querySelector("[data-add-label]");
      const stickyPrice = document.querySelector("[data-sticky-price]");
      if (add && price) add.textContent = `Dodaj do koszyka · ${price}`;
      if (stickyPrice) stickyPrice.textContent = `${price} ${labelText}`.trim();
    }

    form.querySelectorAll('input[name="selling_plan"]').forEach((input) => {
      input.addEventListener("change", () => syncPlan(input));
    });

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const payload = { id: Number(data.get("id")), quantity: Number(data.get("quantity") || 1) };
      const plan = data.get("selling_plan");
      if (plan) payload.selling_plan = Number(plan);
      const error = form.querySelector("[data-form-error]");
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload),
      });
      if (!response.ok) {
        const info = await response.json().catch(() => ({}));
        if (error) {
          error.hidden = false;
          error.textContent = info.description || "Nie udało się dodać do koszyka.";
        }
        return;
      }
      if (error) error.hidden = true;
      await renderCart();
      openCart();
    });
  });

  const sticky = document.querySelector("[data-sticky-submit]");
  if (sticky) {
    sticky.addEventListener("click", () => {
      const form = document.querySelector(".ax-product-form");
      if (form) form.requestSubmit();
    });
  }
})();
